export default "__VITE_ASSET__d79757de__"